import axiosIns from '@/libs/axios'

const ROOT_URL = '/Admin/data/dashboard'
export default {
  namespaced: true,
  state: {
    data: null,
    loading: false,
  },
  getters: {
    data(state) {
      return state.data
    },
    loading(state) {
      return state.loading
    },
  },
  mutations: {
    SET_DATA(state, data) {
      state.data = data
    },
    SET_LOADING(state, data) {
      state.loading = data
    },
  },
  actions: {
    getData({ commit }) {
      commit('SET_LOADING', true)
      return axiosIns
        .post(ROOT_URL)
        .then(response => {
          commit('SET_DATA', response.data)
        })
        .catch(error => console.error(error))
        .finally(() => commit('SET_LOADING', false))
    },
  },
}
